/*
  AUTHOR - KHYATI RADADIYA
  COMPANY NAME - RADIX ANALYTICS
  Version - 1
  Change log
    ----------------------------------------------------------------
    Date         Author   Comment
    ----------------------------------------------------------------
    2024-06-04	  Khyati   This is recreate access token action file
*/

import { toast } from "react-toastify";

import {
  RECREATE_ACCESS_TOKEN_REQUEST,
  RECREATE_ACCESS_TOKEN_SUCCESS,
  RECREATE_ACCESS_TOKEN_FAILURE,
} from "../types";
import axiosInstance from "../../services/axiosInstance";
import logoutAction from "./LogoutAction";

const recreateAccessTokenAction = () => {
  return (dispatch) => {
    dispatch({
      type: RECREATE_ACCESS_TOKEN_REQUEST,
    });
    axiosInstance
      .post(`v1/token/refresh/`, {
        refresh: localStorage.getItem("refresh_token"),
      })
      .then((response) => {
        dispatch({
          type: RECREATE_ACCESS_TOKEN_SUCCESS,
          payload: response.data,
        });
        localStorage.setItem("access_token", response.data.access);
        window.location.reload();
      })
      .catch((error) => {
        if (error.response.data.detail === "Token is invalid or expired") {
          toast.warn("The session has been expired. Please login again.");
          dispatch(logoutAction());
          window.location = "/login";
        }
        dispatch({
          type: RECREATE_ACCESS_TOKEN_FAILURE,
          payload: error.message,
        });
      });
  };
};

export default recreateAccessTokenAction;
